import { HttpClient } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export interface IHelp {
  key: string;
  text: string;
  url?: string;
  target?: '_blank';
  cssClass?: string;
  isDownload?: boolean;
  route?: string;
}

export interface IEnterpriseConfiguration {
  // Application
  isMasterCardUser: boolean;
  enterpriseKey: string;
  theme: string;
  // Header
  logoUrl?: string;
  logoUrlLogin?: string;
  logoLoginHeight?: string;
  logoAnchorUrl?: string;
  logoHeight?: number;
  logoWidth?: number;
  siteName: string;
  headerSiteNameHtml: string;
  siteNameStyle?: string;
  // Footer
  footerLogoUrl?: string;
  footerLogoAnchorUrl?: string;
  copyrightHolder: string;
  legalAnchorUrl?: string;
  contactSalesAnchorText: string;
  contactSalesAnchorUrl?: string;
  contactSupportAnchorText: string;
  contactSupportAnchorUrl?: string;
  technicalSupportAnchorText: string;
  helpGuides: IHelp[];
  associatedEmailDomains: string[];
}

const resourceBasePath = '/api/v1/enterprise-configuration';

@Injectable({
  providedIn: 'root',
})
export class EnterpriseConfigurationDataAccessService {
  private _configuration?: Observable<IEnterpriseConfiguration>;

  constructor(
    private _httpClient: HttpClient,
    private sanitizer: DomSanitizer,
  ) {}

  public getEnterpriseConfiguration(): Observable<IEnterpriseConfiguration> {
    if (!this._configuration) {
      const sanitizedResourceBasePath = this.sanitizer.sanitize(SecurityContext.URL, resourceBasePath);
      if (sanitizedResourceBasePath) {
        this._configuration = this._httpClient
          .get<IEnterpriseConfiguration>(sanitizedResourceBasePath)
          .pipe(shareReplay(1));
      } else {
        throw new Error('unsafe resourceBasePath');
      }
    }
    return this._configuration;
  }
}
